import { TextField, withWidth } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import ContactInfoBadge from "../../Components/Contacts/ContactInfoBadge";
import SortableTable from "../../Components/SortableTable";
import ModuleLandingPage from "../../Components/ModuleLandingPage";
import NewContactDialog from "./NewContactDialog";
import {
  checkAdmin,
  findValueInText,
  formatClientInfoString,
  formatContacts,
  getToken,
  requestErrorHandler,
} from "../../Utils/Common";
import EnvSettings from "../../Utils/EnvSettings";

const server = EnvSettings.server;

function Contacts({ width }) {
  const history = useHistory();
  const [contactsList, setContactsList] = useState([]);
  const [searchList, setSearchList] = useState();
  const [search, setSearch] = useState();
  const { t } = useTranslation();
  const dispatch = useDispatch();

  let getContacts = () => {
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ token: getToken(), search_value: "" }),
    };
    fetch(server + "/get_contacts", requestOptions)
      .then((res) => res.json())
      .then((result) => {
        requestErrorHandler(result, dispatch);
        if (!result.error) {
          setContactsList(formatContacts(result));
        }
      });
  };
  let showCompany = (id) => {
    var type = id.companyId ? "company" : "contact";
    history.push(
      (checkAdmin() ? "/cpanel" : "") +
        "/contacts/" +
        type +
        "/" +
        (id.companyId || id.contactId)
    );
  };

  const handleScrollClick = (event, id) => {
    return;
    // if (window.location.href.includes("/cpanel/")) {
    //   window.open("/cpanel/companies/" + id.id, "_blank");
    // }
  };

  const filterResults = () => {
    if (!contactsList) {
      return;
    }
    setSearchList(
      contactsList.filter((contact) => {
        return (
          findValueInText(contact.name, search) ||
          findValueInText(contact.contactName, search) ||
          findValueInText(contact.companyName, search) ||
          findValueInText(contact.contactEmail, search) ||
          findValueInText(contact.contactPhone, search) ||
          findValueInText(contact.location, search)
        );
      })
    );
  };

  useEffect(getContacts, []);

  useEffect(filterResults, [search, contactsList]);

  return (
    <ModuleLandingPage
      title={t("contacts.header")}
      actions={<NewContactDialog onCreated={getContacts} />}
      filters={
        <Grid item xs={12} sm={4}>
          <TextField
            fullWidth
            variant="outlined"
            label={t("search")}
            onChange={(e) => setSearch(e.target.value)}
          />
        </Grid>
      }
    >
      {width === "xs" ? (
        searchList && searchList.length ? (
          searchList
            .sort((a, b) =>
              a.createdAt > b.createdAt
                ? -1
                : b.createdAt > a.createdAt
                ? 1
                : 0
            )
            .map((val, i) => (
              <ContactInfoBadge
                key={i}
                clientInfoObject={val}
                onClick={() => {
                  showCompany(val);
                }}
                containerStyles={{ marginTop: 10 }}
              />
            ))
        ) : null
      ) : searchList ? (
        <SortableTable
          headCells={[
            {
              id: "companyName",
              numeric: false,
              disablePadding: false,
              label: t("contactInfo.companyName"),
            },
            {
              id: "contactName",
              numeric: false,
              disablePadding: false,
              label: t("contactInfo.contactName"),
            },
            {
              id: "location",
              numeric: false,
              disablePadding: false,
              label: t("contactInfo.location"),
            },
            {
              id: "contactAdditionalInfo",
              numeric: false,
              disablePadding: false,
              label: t("additionalInfo"),
            },
          ]}
          specialDataFormatting={[
            {
              id: "contactAdditionalInfo",
              format: (data, d, dd) => {
                return formatClientInfoString({ ...dd }, [
                  "contactPhone",
                  "contactEmail",
                ]);
              },
            },
          ]}
          defaultSortRow={"companyName"}
          handleRowClick={showCompany}
          handleScrollClick={handleScrollClick}
          tableData={searchList}
          rowsPerPage={200}
          defaultOrder={"asc"}
        />
      ) : undefined}
    </ModuleLandingPage>
  );
}

export default withWidth()(Contacts);
